import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import cn from 'classnames';

import { Icon, Text } from '../../../common/Elements/Elements';

import classes from './PaginationGroup.module.scss';

const PaginationGroup = ({
  pageCount,
  setPage,
  currentPage,
  itemsTotal,
  itemsPerPage,
  autoScrollUp = true
}) => {
  const [resetPagin, setResetPagin] = useState(true);
  const [trigerReset, setTrigerReset] = useState(false);
  const from = (currentPage - 1) * itemsPerPage + 1;
  const to = currentPage * itemsPerPage;
  const itemsRange = `${from} - ${to > itemsTotal ? itemsTotal : to}`;

  useEffect(() => {
    setResetPagin(false);
    setTrigerReset(true);
  }, []);

  useEffect(() => {
    if (trigerReset) {
      setResetPagin(true);
      handlePageChange({ selected: 0 });
    }
    // eslint-disable-next-line
  }, [itemsPerPage]);

  useEffect(() => {
    setResetPagin(false);
  }, [resetPagin]);

  const handlePageChange = page => {
    if (page.selected + 1 !== currentPage) {
      setPage(page.selected + 1);
      if (autoScrollUp) {
        window.scrollTo(0, 0);
      }
    }
  };

  return (
    <>
      <div className={classes.parinWrap}>
        <Text
          size={2}
          className={classes.info}
        >{` ${itemsRange} of ${itemsTotal} results`}</Text>
        {!resetPagin && (
          <ReactPaginate
            breakLabel={'...'}
            containerClassName={classes.pagination}
            pageClassName={classes.pagination_listItem}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={4}
            onPageChange={handlePageChange}
            subContainerClassName={'pages pagination'}
            previousClassName={classes.arrowWrap}
            previousLabel={
              <Icon
                size="20px"
                icon={'arrow'}
                color={'#3a5ba2'}
                className={cn(classes.arrow, classes.arrow_left)}
              />
            }
            nextClassName={classes.arrowWrap}
            nextLabel={
              <Icon
                size="20px"
                icon={'arrow'}
                color={'#3a5ba2'}
                className={cn(classes.arrow, classes.arrow_right)}
              />
            }
            breakClassName={classes.pagination_listItem}
            activeClassName={classes.pagination_active}
            initialPage={currentPage - 1}
          />
        )}
      </div>
    </>
  );
};

PaginationGroup.propTypes = {
  pageCount: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  itemsTotal: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  autoScrollUp: PropTypes.bool
};

export default PaginationGroup;
